export type IconName =
  | 'home' | 'document' | 'shield' | 'table' | 'folder'
  | 'users' | 'meter' | 'clipboard' | 'antenna' | 'insight';

export interface NavItem {
  to: string;
  label: string;
  icon: IconName;
}

export interface NavRoles {
  isAdmin: boolean;
  hasFieldRole: boolean;
  canAudit: boolean;
}

const DASHBOARD: NavItem = { to: '/', label: 'Dashboard', icon: 'home' };
const BILL_RUNS: NavItem = { to: '/bill-runs', label: 'Bill Runs', icon: 'document' };
const VERIFICATION: NavItem = { to: '/verification', label: 'Verification', icon: 'shield' };
const TARIFFS: NavItem = { to: '/tariff-management', label: 'Tariffs', icon: 'table' };
const POCKETS: NavItem = { to: '/pockets', label: 'Pockets', icon: 'folder' };
const TENANTS: NavItem = { to: '/tenants', label: 'Tenants', icon: 'users' };
const METERS: NavItem = { to: '/meter-config', label: 'Meters', icon: 'meter' };
const VIRTUAL_METERS: NavItem = { to: '/virtual-meters', label: 'Virtual Meters', icon: 'meter' };
const AUDIT_LOGS: NavItem = { to: '/audit-logs', label: 'Audit Logs', icon: 'clipboard' };
const FIELD_TOOLS: NavItem = { to: '/field-tools', label: 'Field Tools', icon: 'antenna' };
const INSIGHTS: NavItem = { to: '/insights', label: 'Insights', icon: 'insight' };

/** Full navigation list — drawer at lg+, More sheet below. Insights is always last. */
export function allNavItems({ hasFieldRole, canAudit }: NavRoles): NavItem[] {
  return [
    DASHBOARD, BILL_RUNS, VERIFICATION, TARIFFS, POCKETS, TENANTS, METERS, VIRTUAL_METERS,
    ...(canAudit ? [AUDIT_LOGS] : []),
    ...(hasFieldRole ? [FIELD_TOOLS] : []),
    INSIGHTS,
  ];
}

/**
 * The three primary bottom-bar destinations; the fourth slot is always More.
 * Field users lead with Field Tools because a phone is their primary device.
 */
export function tabItems({ isAdmin, hasFieldRole }: NavRoles): NavItem[] {
  if (hasFieldRole) return [FIELD_TOOLS, DASHBOARD, BILL_RUNS];
  if (isAdmin) return [DASHBOARD, BILL_RUNS, VERIFICATION];
  return [DASHBOARD, BILL_RUNS, INSIGHTS];
}
